// extracted by mini-css-extract-plugin
export var table = "_v0-0";